import * as React from 'react'

const DownloadMicrosoftExcel = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & { color?: string }
>(({ color = '#fff', ...props }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    fill="none"
    viewBox="0 0 19 20"
    {...props}
    ref={ref}
  >
    <path
      fill={color}
      d="M2.5 15.875c0 .813.515 1.5 1.125 1.5a.97.97 0 0 0 .687-.322 1.125 1.125 0 0 1 1.626 1.557 3.19 3.19 0 0 1-2.313 1.015c-1.86 0-3.375-1.687-3.375-3.75s1.514-3.75 3.375-3.75a3.19 3.19 0 0 1 2.313 1.015 1.125 1.125 0 0 1-1.626 1.557.96.96 0 0 0-.687-.322c-.61 0-1.125.685-1.125 1.5m9.142-.535c-.481-.324-1.063-.492-1.575-.64a8 8 0 0 1-.742-.242c.23-.111.91-.122 1.507.03a1.125 1.125 0 1 0 .574-2.175 6.5 6.5 0 0 0-1.125-.175c-.93-.062-1.687.101-2.26.485a2.3 2.3 0 0 0-1.001 1.665c-.103.82.232 1.525.948 1.986.448.29.97.441 1.476.587.281.084.744.216.926.331a.2.2 0 0 1-.02.067c-.128.145-.897.168-1.537-.006a1.125 1.125 0 0 0-.605 2.167 6 6 0 0 0 1.52.205c.606 0 1.287-.11 1.85-.483a2.32 2.32 0 0 0 1.026-1.687c.115-.874-.23-1.624-.962-2.117zm6.608-3.151a1.125 1.125 0 0 0-1.434.686L16 15.153l-.816-2.278a1.125 1.125 0 1 0-2.118.75l1.875 5.25a1.125 1.125 0 0 0 2.118 0l1.875-5.25a1.125 1.125 0 0 0-.684-1.436M1.375 9.125V2.75A1.875 1.875 0 0 1 3.25.875h9a1.13 1.13 0 0 1 .796.33l5.25 5.25a1.13 1.13 0 0 1 .329.795v1.875a1.125 1.125 0 1 1-2.25 0V8.75h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5H3.625v6a1.125 1.125 0 0 1-2.25 0M13 6.5h2.156L13 4.344z"
    ></path>
  </svg>
))

DownloadMicrosoftExcel.displayName = 'DownloadMicrosoftExcel'

export { DownloadMicrosoftExcel }
